import { isObject } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Icon from 'components/Icon'
import TooltipButton from 'components/TooltipButton'
import { ResizeConsumer } from 'contexts/Resize'
import { TextLH } from 'styles/components/typography'

import { Wrapper, IconBox, TextBox, TooltipBox } from './styles'

export default class OrderFieldInfo extends Component {
  static propTypes = {
    children: PropTypes.node,
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  renderTooltip = () => {
    const { children } = this.props

    return (
      <TooltipBox>
        <TooltipButton
          isMobile={true}
          content={
            isObject(children) ? (
              children
            ) : (
              <TextLH dangerouslySetInnerHTML={{ __html: children }} />
            )
          }
        >
          <IconBox>
            <Icon id="btn_info" color="black" />
          </IconBox>
        </TooltipButton>
      </TooltipBox>
    )
  }

  renderStaticInfo = () => {
    const { children } = this.props

    return (
      <div className="col-md-5 col-lg-6">
        <Wrapper className="pl-md-1">
          <IconBox>
            <Icon id="btn_info" color="black" />
          </IconBox>
          <TextBox>
            {isObject(children) ? (
              children
            ) : (
              <TextLH dangerouslySetInnerHTML={{ __html: children }} />
            )}
          </TextBox>
        </Wrapper>
      </div>
    )
  }

  render() {
    const { children } = this.props

    if (!children) {
      return null
    }

    return (
      <ResizeConsumer>
        {({ mobile, breakpoint }) => {
          if (breakpoint === '') {
            return ''
          }

          return mobile ? this.renderTooltip() : this.renderStaticInfo()
        }}
      </ResizeConsumer>
    )
  }
}
